import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { UserIdleService } from '../../../../src/app/services/user-idle.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  [x: string]: any;
  title = environment.title;

  constructor(
    private metaTitle: Title,
    private meta: Meta
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.metaTitle.setTitle(`${environment.title} | ${environment.subtitle}`);
    this.meta.addTags([
      { name: 'description', content: `${environment.description}.` },
      { name: 'keywords', content: environment.keywords },
    ]);
  }

  // ngOnInit() {
  //   this['userIdleService'].startWatching(() => {
  //     alert('Estás inactivo desde hace 5 minutos.');
  //   });
  // }
}
